function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var GameWizardTemplate = require('./wizard.template.js');
var CryptoStakingOverlay = require('./crypto-staking-overlay.js');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay.js');

//
// {
//    game   : module_name
//    league : league_obj { id , name , mod }
// }
//
var GameWizard = /*#__PURE__*/function () {
  function GameWizard(app, mod) {
    var _this = this;
    var game_mod = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var obj = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    _classCallCheck(this, GameWizard);
    this.app = app;
    this.mod = mod;
    this.game_mod = game_mod;
    this.overlay = new SaitoOverlay(app, mod);
    this.crypto_staking_overlay = new CryptoStakingOverlay(app, mod);
    this.obj = obj;
    this._invite_menu_closer = null;
    app.connection.on('arcade-launch-game-wizard', /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(obj) {
        var _game_mod;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(obj !== null && obj !== void 0 && obj.game)) {
                _context.n = 3;
                break;
              }
              _game_mod = _this.app.modules.returnModuleByName(obj.game);
              if (!_game_mod) {
                _context.n = 2;
                break;
              }
              if (!(_game_mod.is_teaser || _game_mod.teaser === true)) {
                _context.n = 1;
                break;
              }
              _this.app.connection.emit('arcade-teaser-install-render-request', {
                game_mod: _game_mod,
                title: _game_mod.returnName ? _game_mod.returnName() : _game_mod.name,
                image: _game_mod.img || '',
                link: _game_mod.link || '',
                description: _game_mod.description || ''
              });
              return _context.a(2);
            case 1:
              //
              // We do a little check that if we already have a game in the options,
              // we prompt them to continue that one instead of creating a new game
              //
              if (_game_mod.doWeHaveAnOngoingGame()) {
                if (obj.skip) {
                  navigateWindow("/".concat(_game_mod.returnSlug(), "/"));
                } else {
                  console.info('arcade-launch-game-wizard found existing game', _game_mod.game);
                  app.connection.emit('arcade-continue-game-from-options', _game_mod);
                }
              } else {
                //Launch game wizard
                _this.game_mod = _game_mod;
                _this.obj = obj;
                _this.render();
              }
              _context.n = 3;
              break;
            case 2:
              console.error('arcade-launch-game-wizard -- game module not found!', obj);
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  }
  return _createClass(GameWizard, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this2 = this,
          _this$obj;
        var advancedOptions, advanced_btn, accept_button, btn;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              //
              // Create the game wizard overlay
              //  & set a callback to remove the advanced options overlay if we change our mind about creating a game
              //
              if (this.mod.debug) {
                console.debug('ARCADE: render game-wizard for: ', JSON.parse(JSON.stringify(this.obj)));
              }
              this.detachInviteMenuCloser();
              this.overlay.show(GameWizardTemplate(this.game_mod, this.obj), function () {
                _this2.detachInviteMenuCloser();
                if (_this2.meta_overlay) {
                  _this2.meta_overlay.remove();
                }
              });
              this.overlay.setBackground(this.game_mod.respondTo('arcade-games').image);

              //Test if we should include Advanced Options
              advancedOptions = this.game_mod.returnAdvancedOptions();
              if (!advancedOptions) {
                advanced_btn = document.querySelector('.arcade-wizard .advanced-btn');
                if (advanced_btn) {
                  advanced_btn.hidden = true;
                }
              } else {
                accept_button = "<div id=\"game-wizard-advanced-return-btn\" class=\"game-wizard-advanced-return-btn saito-button-primary\">Accept</div>";
                if (!advancedOptions.includes(accept_button)) {
                  advancedOptions += accept_button;
                }
                advancedOptions = "<div id=\"advanced-options-overlay-container\">".concat(advancedOptions, "</div>");
                this.meta_overlay = new SaitoOverlay(this.app, this.mod, false, false); // Have to manually delete when done
                this.meta_overlay.show(advancedOptions);
                this.meta_overlay.hide();
              }

              //Hook for Crypto module (if installed) to add button to attach functionality
              _context2.n = 1;
              return this.app.modules.renderInto('#arcade-advance-opt');
            case 1:
              this.attachCryptoHookEvents();
              this.attachEvents();
              if ((_this$obj = this.obj) !== null && _this$obj !== void 0 && _this$obj.skip) {
                if (this.game_mod.maxPlayers === 1) {
                  if (!this.game_mod.returnSingularGameOption() && !advancedOptions) {
                    btn = document.querySelector('.arcade-wizard .game-invite-btn');
                    if (btn) {
                      btn.click();
                    }
                  }
                }
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "userHasNoTokens",
    value: function () {
      var _userHasNoTokens = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var balances, ticker, _t, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return this.app.wallet.returnAvailableCryptosAssociativeArray();
            case 1:
              balances = _context3.v;
              _t = _regeneratorKeys(balances);
            case 2:
              if ((_t2 = _t()).done) {
                _context3.n = 4;
                break;
              }
              ticker = _t2.value;
              if (!(parseFloat(balances[ticker].balance) > 0)) {
                _context3.n = 3;
                break;
              }
              return _context3.a(2, false);
            case 3:
              _context3.n = 2;
              break;
            case 4:
              return _context3.a(2, true);
          }
        }, _callee3, this);
      }));
      function userHasNoTokens() {
        return _userHasNoTokens.apply(this, arguments);
      }
      return userHasNoTokens;
    }()
  }, {
    key: "attachCryptoHookEvents",
    value: function attachCryptoHookEvents() {
      var _this3 = this;
      var hook = document.querySelector('.game-wizard-crypto-hook');
      if (!hook) {
        return;
      }
      var original_onclick = hook.onclick;
      hook.onclick = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(e) {
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.n) {
              case 0:
                _context4.n = 1;
                return _this3.userHasNoTokens();
              case 1:
                if (!_context4.v) {
                  _context4.n = 2;
                  break;
                }
                _this3.crypto_staking_overlay.render();
                return _context4.a(2);
              case 2:
                if (original_onclick) {
                  original_onclick.call(hook, e);
                }
              case 3:
                return _context4.a(2);
            }
          }, _callee4);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }();
    }
  }, {
    key: "detachInviteMenuCloser",
    value: function detachInviteMenuCloser() {
      if (this._invite_menu_closer) {
        document.removeEventListener('click', this._invite_menu_closer, true);
        this._invite_menu_closer = null;
      }
    }
  }, {
    key: "closeInviteMenu",
    value: function closeInviteMenu() {
      var control = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var root = control || document.querySelector('.arcade-wizard .invite-control');
      if (!root) {
        return;
      }
      var menu = root.querySelector('.invite-menu');
      var toggle = root.querySelector('.invite-toggle');
      if (menu) {
        menu.hidden = true;
      }
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      }
    }

    //
    // Note: mod = Arcade
    //
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this4 = this;
      var root = document.querySelector('.arcade-wizard');
      if (!root) {
        return;
      }
      var invite_control = root.querySelector('.invite-control');
      if (invite_control) {
        var toggle = invite_control.querySelector('.invite-toggle');
        var menu = invite_control.querySelector('.invite-menu');
        var primary = invite_control.querySelector('.invite-primary');
        if (toggle && menu) {
          toggle.onclick = function (e) {
            e.preventDefault();
            e.stopPropagation();
            var open = menu.hidden;
            menu.hidden = !open;
            toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          };
          this.detachInviteMenuCloser();
          this._invite_menu_closer = function (e) {
            if (!invite_control.contains(e.target)) {
              _this4.closeInviteMenu(invite_control);
            }
          };
          document.addEventListener('click', this._invite_menu_closer, true);
          root.querySelectorAll('.invite-option').forEach(function (opt) {
            opt.onclick = /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(e) {
                var gameType;
                return _regenerator().w(function (_context5) {
                  while (1) switch (_context5.n) {
                    case 0:
                      e.preventDefault();
                      e.stopPropagation();
                      gameType = opt.getAttribute('data-type');
                      _this4.closeInviteMenu(invite_control);
                      _context5.n = 1;
                      return _this4.submitInvite(gameType);
                    case 1:
                      return _context5.a(2);
                  }
                }, _callee5);
              }));
              return function (_x3) {
                return _ref3.apply(this, arguments);
              };
            }();
          });
        }
        if (primary) {
          primary.onclick = /*#__PURE__*/function () {
            var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(e) {
              return _regenerator().w(function (_context6) {
                while (1) switch (_context6.n) {
                  case 0:
                    e.preventDefault();
                    e.stopPropagation();
                    _context6.n = 1;
                    return _this4.submitInvite(primary.getAttribute('data-type'));
                  case 1:
                    return _context6.a(2);
                }
              }, _callee6);
            }));
            return function (_x4) {
              return _ref4.apply(this, arguments);
            };
          }();
        }
      }

      //
      // Display Advanced Options Overlay
      //
      var advancedOptionsToggle = root.querySelector('.advanced-btn');
      if (advancedOptionsToggle) {
        advancedOptionsToggle.onclick = function (e) {
          _this4.meta_overlay.show();
          _this4.game_mod.attachAdvancedOptionsEventListeners();
          _this4.meta_overlay.blockClose('#game-wizard-advanced-return-btn');
          if (document.getElementById('game-wizard-advanced-return-btn')) {
            document.querySelector('.game-wizard-advanced-return-btn').onclick = function (e) {
              _this4.meta_overlay.hide();
            };
          }
        };
      }

      //
      // Display Rules Overlay
      //
      if (document.getElementById('game-rules-btn')) {
        document.getElementById('game-rules-btn').onclick = function () {
          var rules_overlay = new SaitoOverlay(_this4.app, _this4.mod);
          rules_overlay.show(_this4.game_mod.returnGameRulesHTML());
        };
      }

      //
      // Single-player Play button
      //
      var play_btn = root.querySelector('.game-invite-btn[data-type="single"]');
      if (play_btn) {
        play_btn.onclick = /*#__PURE__*/function () {
          var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(e) {
            return _regenerator().w(function (_context7) {
              while (1) switch (_context7.n) {
                case 0:
                  e.preventDefault();
                  e.stopPropagation();
                  _context7.n = 1;
                  return _this4.submitInvite('single');
                case 1:
                  return _context7.a(2);
              }
            }, _callee7);
          }));
          return function (_x5) {
            return _ref5.apply(this, arguments);
          };
        }();
      }
    }
  }, {
    key: "submitInvite",
    value: function () {
      var _submitInvite = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var gameType,
          options,
          _args8 = arguments;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              gameType = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : 'open';
              options = this.getOptions();
              this.detachInviteMenuCloser();
              this.overlay.remove();
              if (!(gameType == 'private')) {
                _context8.n = 1;
                break;
              }
              _context8.n = 6;
              break;
            case 1:
              if (!(gameType == 'single')) {
                _context8.n = 3;
                break;
              }
              if (!(typeof this.game_mod.launchFromArcadeWizard === 'function')) {
                _context8.n = 2;
                break;
              }
              this.game_mod.launchFromArcadeWizard(options, this.obj);
              return _context8.a(2);
            case 2:
              this.mod.makeGameInvite(options, 'private', this.obj);
              return _context8.a(2);
            case 3:
              if (!(gameType == 'direct')) {
                _context8.n = 4;
                break;
              }
              _context8.n = 6;
              break;
            case 4:
              if (!(gameType == 'async')) {
                _context8.n = 6;
                break;
              }
              if (!(options['game-wizard-players-select'] > 2)) {
                _context8.n = 5;
                break;
              }
              salert('Asynchronous game creation is experimental and assumes there are only two players!');
              return _context8.a(2);
            case 5:
              options.async_dealing = 1;
              gameType = 'private';
              _context8.n = 6;
              break;
            case 6:
              this.mod.makeGameInvite(options, gameType, this.obj);
            case 7:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function submitInvite() {
        return _submitInvite.apply(this, arguments);
      }
      return submitInvite;
    }()
  }, {
    key: "getOptions",
    value: function getOptions() {
      var options = {};
      document.querySelectorAll('#advanced-options-overlay-container input, #advanced-options-overlay-container select, .arcade-wizard input, .arcade-wizard select').forEach(function (element) {
        if (element.name) {
          if (element.type == 'checkbox') {
            if (element.checked) {
              options[element.name] = 1;
            }
          } else if (element.type == 'radio') {
            if (element.checked) {
              options[element.name] = element.value;
            }
          } else {
            options[element.name] = element.value;
          }
        }
      });
      if (document.querySelector('.game-wizard-crypto-hook')) {
        var _hook$dataset, _hook$dataset2;
        var hook = document.querySelector('.game-wizard-crypto-hook');
        if ((_hook$dataset = hook.dataset) !== null && _hook$dataset !== void 0 && _hook$dataset.ticker && (_hook$dataset2 = hook.dataset) !== null && _hook$dataset2 !== void 0 && _hook$dataset2.amount) {
          options['crypto'] = hook.dataset.ticker;
          options['stake'] = hook.dataset.amount;
          if (hook.dataset.match != undefined) {
            options['stake'] = {
              min: parseFloat(hook.dataset.match)
            };
            options['stake'][this.mod.publicKey] = parseFloat(hook.dataset.amount);
          }
        }
      }
      if (this.mod.debug) {
        console.debug('ARCADE game-wizard -- reading options from HTML: ', JSON.parse(JSON.stringify(options)));
      }
      if (this.meta_overlay) {
        this.meta_overlay.remove();
      }

      // Check for open table here
      if (options['game-wizard-players-select'] == 'open-table') {
        options['open-table'] = 1;
        options['game-wizard-players-select'] = 2;
        options['game-wizard-players-select-max'] = 6;
      }
      return options;
    }
  }]);
}();
module.exports = GameWizard;